import React, { useEffect } from 'react';
import { ToggableDropdown } from 'dyl-components';
import { Controller } from 'react-hook-form';
import { Form, Segment } from 'semantic-ui-react';

import './DataMapping.scss';
import { useDispatch, useSelector } from 'react-redux';
import customFieldsGroupActions from 'actions/custom_fields_group';
import { CustomGroupUtils } from 'utils';

const DataMapping = ({
    importSetupFields,
    dataMappingControl,
    mappingTable,
    module,
    isReadingProductInterests,
    product_interests,

    productInterestsSelectedAsDylField,
    interestsSelectedAsDylField,
    getSubgroups,
    groupOptions,
    isReadingGroups,
    campaignListOptions
}) => {
    const productInterests = product_interests?.map((item) => ({ ...item, value: item.id, text: item.name })) || [];
    const { group } = useSelector(state => ({
        group: state.custom_fields_group.page_standard_group,
    }));
    const groupFields = group?.fields?.data || [];
    const intrest_options = CustomGroupUtils.getFieldOptions(groupFields, 'interests');
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(customFieldsGroupActions.getPageStandardGroup({ group_name: 'person' }));

    }, [dispatch])
    return (
        <React.Fragment>
            <Segment className='DataMapping__DataField'>
                <Form noValidate>
                    <Form.Group widths='equal'>
                        {importSetupFields}
                        {module === 'Contact' ? (
                            <Controller
                                name='interests'
                                control={dataMappingControl}
                                render={({ field: { name, value, onChange } }) => (
                                    <Form.Select
                                        name={name}
                                        label='Interest(s)'
                                        value={value}
                                        placeholder='Select'
                                        onChange={(_, { value }) => {
                                            onChange({
                                                target: {
                                                    name, value
                                                }
                                            })
                                        }}
                                        multiple
                                        selectOnBlur={false}
                                        {...(!interestsSelectedAsDylField ? {} : {
                                            disabled: true,
                                            text: 'Selected as a DYL Field'
                                        } )}
                                        options={intrest_options}
                                    />
                                )}
                            />
                        ) : (
                            <Controller
                                name='product_interests'
                                control={dataMappingControl}
                                render={({ field: { name, value, onChange } }) => (
                                    <Form.Select
                                        name={name}
                                        label='Product Interest(s)'
                                        value={value}
                                        placeholder='Select'
                                        onChange={(_, { value }) => {
                                            onChange({
                                                target: {
                                                    name, value
                                                }
                                            })
                                        }}
                                        multiple
                                        selectOnBlur={false}
                                        {...(!productInterestsSelectedAsDylField ? {} : {
                                            disabled: true,
                                            text: 'Selected as a DYL Field'
                                        })}
                                        options={productInterests}
                                        loading={isReadingProductInterests}
                                    />
                                )}
                            />
                        )}

                        <Controller
                            name='group'
                            control={dataMappingControl}
                             render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                                                                <Form.Field
                                                                    control={ToggableDropdown}
                                                                    value={value}
                                                                    nested_options={groupOptions}
                                                                    onChange={( _, { value }) => {
                                                                        onChange({ target: { name, value }});
                                                                    }}
                                                                    
                                                                    label='Add to group'
                                                                    onHoverParent={getSubgroups}
                                                                    loading={isReadingGroups}
                                                                    width='4'
                                                                    selection
                                                                    className='Fix_Width_Dropdown'
                                                                />
                                                            )}
                        />
                        <Controller
                            name='campaign'
                            control={dataMappingControl}
                            render={({ field: { name, value, onChange } }) => (
                                <Form.Select
                                    name={name}
                                    label='Add to campaign'
                                    value={value}
                                    placeholder='Select'
                                    onChange={(_, { value }) => {
                                        onChange({
                                            target: {
                                                name, value
                                            }
                                        })
                                    }}
                                    options={campaignListOptions}
                                    selectOnBlur={false}
                                    className='Fix_Width_Dropdown'
                                />
                            )}
                        />
                    </Form.Group>
                </Form>
            </Segment>
            {mappingTable}
        </React.Fragment>
    )
};

export default DataMapping;
